import styled from 'styled-components';

export const Wrap = styled.div`
  display:flex;
  justify-content:space-between;
`


export const Left =styled.div`
  width:4.55rem;
`

export const Right =styled.div`
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  width:2.93rem;
  height:11.4rem
`

